import { Navigate, useNavigate, useRoutes } from "react-router-dom";
import { useAuthStore } from "./store/useAuthStore";
import MainLayout from "./layout/MainLayout";
import { useRefetchAccessToken } from "./queries/auth";
import { useEffect, useState } from "react";
import { decodeAuthToken } from "./utils/auth";
import HomePage from "./pages/dashboard/HomePage";
import LoginLayout from "./layout/LoginLayout";
import { ResetPasswordPage } from "./pages/auth/resetPassword";
import Loader from "./utils/loader";
import { ExplorePage } from "./pages/explore/ExplorePage";
import { DemoBookWrapper } from "./layout/DemoBook";
import { UserProfilePage } from "./layout/TopBar/components/UserProfilePage";
import RegistrationPage from "./pages/auth/RegistrationPage";
import { useFeatureFlag } from "./FeatureFlags";

const ExternalRedirect = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);
  return <Loader />;
};

export default function Router() {
  const { isAuthenticated, setAuth } = useAuthStore();
  const isMarketplace = useFeatureFlag("allowUserRegistration");
  const hasLoggedOut = useAuthStore((s) => s.hasLoggedOut);
  const { data, isLoading, isError } = useRefetchAccessToken(!isAuthenticated && !(isMarketplace && hasLoggedOut)); // Fetch token if not authenticated; suppress refetch after explicit logout in marketplace mode
  const [checkedAuth, setCheckedAuth] = useState(false);
  const hasAccessToRegister = useFeatureFlag('allowUserRegistration');
  const marketplaceLink = process.env.REACT_APP_MARKETPLACE_URL;

  useEffect(() => {
    if (!isLoading) {
      if (data) {
        const accessToken = data;
        const decodedJwt = decodeAuthToken(accessToken);
        setAuth({
          accessToken: data,
          isAuthenticated: true,
          email: decodedJwt.emailId,
          name: decodedJwt.fullName,
          id: decodedJwt.id,
        });
      }
      setCheckedAuth(true); // Mark auth check as complete
    }
  }, [data, isError]);

  const routes = useRoutes([
    {
      path: "/*",
      element: isAuthenticated ? (
        <Navigate to="/landing/dashboard" />
      ) : (
        <Navigate to="/login" replace={isMarketplace} />
      ),
    },
    {
      path: "/register",
      element: hasAccessToRegister ? <RegistrationPage /> : <Navigate to="/login" />
    },
    {
      path: "/login",
      element: isAuthenticated ? (
        <Navigate to="/landing/dashboard" />
      ) : (
        <LoginLayout />
      ),
    },
    {
      path: "/resetpassword",
      element: <ResetPasswordPage />,
    },
    {
      path: "/landing",
      element: isAuthenticated ? <MainLayout /> : <Navigate to="/login" replace={isMarketplace} />,
      children: isMarketplace ?[
        {
          path: "dashboard",
          element: <ExternalRedirect url={marketplaceLink || '/login'} />,
        },
      ] : [
        {
          path: "dashboard",
          element: <HomePage />,
          index: true,
        },
        {
          path: 'explore/:platform',
          element: <ExplorePage />
        },
        {
          path: 'demo',
          element: <DemoBookWrapper />
        },
        {
          path: 'userProfile',
          element: <UserProfilePage />
        }
      ],
    },
  ]);
  if  (!checkedAuth) {
    return <Loader />;
  } else return routes;
}
